const ASYNC_JOB_STATUSES = {
  scheduled: { name: "scheduled", id: "scheduled" },
  complete: { name: "complete", id: "complete" },
  failed: { name: "failed", id: "failed" },
  processing: { name: "processing", id: "processing" },
};

export default ASYNC_JOB_STATUSES;
